import type { RichiestaModuloDTO } from '@framework/api-client';
import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { mapSubmissionModuleState } from '../../submission/state/mapSubmissionModuleState';

export interface IUseFrontOfficeModuleParams {
  data: RichiestaModuloDTO | undefined;
}

export type IUseFrontOfficeModuleResult = ReturnType<
  typeof useFrontOfficeModule
>;

/**
 * Mappa i moduli tornati dall'API a un formato utilizzabile per il frontoffice
 */
export function useFrontOfficeModule(params: IUseFrontOfficeModuleParams) {
  const { data } = params;

  return useMemo(() => {
    const module = data?.modulo?.modulo;
    const sections = data?.modulo?.sezioni;
    if (!module) return null;

    return {
      moduloRichiestaId: data.id,
      domandaModulo: data?.domandaModulo,
      ...module,
      permessi: data.permessi,
      idFileFirmato: data.idFileFirmato,
      statoValidazione: data.statoValidazione,
      valori: data.valoriSezioni,
      flagDigitalSignature: data.flagDigitalSignature,
      sezioni: sortBy(sections, 'ordine'),
      stato: mapSubmissionModuleState(data.statoCompilazione),
      titoloModuloDinamico: data.titoloModuloDinamico,
      verificaFirmaAutografaAi: data.verificaFirmaAutografaAi,
    };
  }, [data]);
}
